import useTracker from './useTracker';

const Tracker: React.FC<{}> = () => {
  useTracker();

  return null;
};

export default Tracker;
